<template>
	<div class="index">
		<div class="index-top">
			<img
				:src="require('@/assets/images/indextop.gif')"
				class="image-width"
				alt=""
			/>
		</div>
		<div class="index-textimg">
			<div class="index-textimg-img">
				<img
					:src="require('@/assets/images/indextheme.png')"
					class="img-size"
					alt=""
				/>
			</div>
			<div class="index-textimg-name">{{ $t('产品分类') }}</div>
		</div>
		<div class="index-class">
			<div
				class="index-class-item"
				v-for="(item, index) in productList"
				@click="Toprosec(item)"
				:key="index"
			>
				<div class="class-item-left">
					<div class="item-left-img">
						<img :src="item.smallPicSJ" class="image-width" alt="" />
					</div>
				</div>
				<div class="class-item-rig">
					<div class="item-rig-text">{{ getLangText(item, 'name') }}</div>
					<div class="item-rig-rigarrow">></div>
				</div>
			</div>
		</div>
		<div class="index-about">
			<img
				:src="require('@/assets/images/aboutcp.png')"
				class="img-size"
				alt=""
			/>
			<div class="index-about-box">
				<div class="index-about-o">
					<div class="index-about-us">
						<img
							:src="require('@/assets/images/aboutus.png')"
							class="image-width"
							alt=""
						/>
						<div class="about-us-text">{{ $t('关于三环') }}</div>
					</div>
				</div>
				<div class="index-about-text">
					{{
						$t(
							'潮州三环（集团）股份有限公司成立于1970年，并于2014年在深交所上市（证券简称：三环集团；证券代码：300408），是全国领先的电子元件、先进材料产业基地。'
						)
					}}
				</div>
				<div class="index-about-nav">
					<div
						class="about-nav-item"
						v-for="(item, index) in aboutlist"
						@click="Todetail(index)"
						:key="index"
					>
						<div class="nav-item-img">
							<div class="item-img-self">
								<img :src="item.img" class="image-width" alt="" />
							</div>
						</div>
						<div class="nav-item-text">{{ item.name }}</div>
					</div>
				</div>
			</div>
		</div>
		<div class="index-new">
			<div class="index-new-img">
				<img
					:src="require('@/assets/images/homenew.png')"
					class="img-size"
					alt=""
				/>
				<div class="new-img-text">{{ $t('新闻公告') }}</div>
			</div>
			<div class="index-new-swipe">
				<!-- :autoplay="3000" -->
				<van-swipe class="new-swipe-self" :show-indicators="false" ref="swipe">
					<van-swipe-item
						v-for="(item, index) in newsList"
						:key="index"
						class="swipe-self-item"
					>
						<div class="self-item-con">
							<div class="item-con-img">
								<img :src="item.newsImg" class="image-width" alt="" />
							</div>
							<div class="item-con-bom">
								<div class="con-bom-lef">
									<div class="bom-lef-one">
										<div class="lef-one-img">
											<img
												:src="require('@/assets/images/circletime.png')"
												class="image-width"
												alt=""
											/>
										</div>
										<div class="lef-one-text">{{ item.newsDate }}</div>
									</div>
									<!-- todo en title -->
									<div class="bom-lef-two">
										{{ getLangText(item, 'newsContentTitle') }}
									</div>
								</div>
								<div class="con-bom-rig">
									<div class="bom-rig-btn" @click="Lookdetail(item)">
										<span class="rig-btn-text">{{ $t('查看详情') }}</span>
										<span class="rig-btn-img">
											<img
												:src="require('@/assets/images/arrowcircle.png')"
												class="image-width"
												alt=""
											/>
										</span>
									</div>
								</div>
							</div>
						</div>
					</van-swipe-item>
				</van-swipe>
				<div class="new-swipe-arrow">
					<div class="swipe-arrow-left" @click="Clickswipe(1)">
						<img
							:src="require('@/assets/images/arrowleft.png')"
							class="image-width"
							alt=""
						/>
					</div>
					<div class="swipe-arrow-right" @click="Clickswipe(2)">
						<img
							:src="require('@/assets/images/arrowrig.png')"
							class="image-width"
							alt=""
						/>
					</div>
				</div>
			</div>
			<div class="index-new-more" @click="Tomorenews">
				<div class="new-more-text">{{ $t('更多新闻') }}</div>
				<div class="new-more-img">
					<img
						:src="require('@/assets/images/arrowcircle.png')"
						class="image-width"
						alt=""
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { getNewsList } from '@/api';

export default {
	data() {
		return {
			aboutlist: [
				{
					name: this.$t('关于我们'),
					img: require('@/assets/images/gywm.png')
				},
				{
					name: this.$t('里程碑'),
					img: require('@/assets/images/lcb.png')
				},
				{
					name: this.$t('企业文化'),
					img: require('@/assets/images/qywh.png')
				},
				{
					name: this.$t('视频宣传'),
					img: require('@/assets/images/spxc.png')
				},
				{
					name: this.$t('集团荣誉'),
					img: require('@/assets/images/jtry.png')
				},
				{
					name: this.$t('领导关怀'),
					img: require('@/assets/images/ldgh.png')
				}
			],
			newsList: [],
			proclassindata: []
		};
	},
	created() {
		this.newsListFZ();
	},
	computed: {
		productList() {
			return this.$store.getters.productList;
		}
	},
	methods: {
		//新闻内容接口
		newsListFZ() {
			let params = {
				pageNum: 1,
				pageSize: 4,
				language: Number(this.lang === 'en')
			};

			getNewsList(params).then(res => {
				this.newsList = res.rows;
			});
		},
		//跳转产品二级页
		Toprosec(item) {
			this.$store.commit('setKeepAlive', ['Prodoctsec']); //设置缓存
			localStorage.setItem('productSecItem', JSON.stringify(item));

			this.$router.push({
				name: 'Prodoctsec',
				query: {
					lang: this.lang
				}
			});
		},
		//新闻查看详情
		Lookdetail(item) {
			localStorage.setItem('newsData', JSON.stringify(item));
			this.$router.push({
				name: 'Newscontent',
				query: {
					lang: this.lang,
					newsId: item.newsContentId
				}
			});
		},
		//更多新闻
		Tomorenews() {
			this.$router.push(`/Newscenter?lang=${this.lang}`);
		},
		//点击箭头
		Clickswipe(num) {
			if (num == 1) {
				this.$refs.swipe.prev();
			} else {
				this.$refs.swipe.next();
			}
		},
		//跳转详情
		Todetail(index) {
			let path = '';
			switch (index) {
				case 0:
					path = '/Aboutus';
					break;
				case 1:
					path = '/Milestone';
					break;
				case 2:
					path = '/Companycultrue';
					break;
				case 3:
					path = '/Videopublicity';
					break;
				case 4:
					path = '/Grouphonor';
					break;
				case 5:
					path = '/Leadercare';
					break;
			}
			this.$router.push(path + `?lang=${this.lang}`);
		}
	}
};
</script>

<style lang="scss">
@use './Home.scss';
</style>
